import React from "react";
import { Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  FabricSalesActivityPrintRequest,
  FabricStyleYearlySalesCriteriaBean,
  RestPageListBean,
  SalesAnalaysisActivityPeriodDataBean,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { ReportService } from "../services/ReportService.js";
class SalesAnalysis extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Sales Analysis Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new FabricStyleYearlySalesCriteriaBean(),
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: "",
      alertMsg: [],
      success_list: [],
      inquiryData: null,
      isDisableFields: false,
      progressLoadingText: "",
      isShowProgressBarPopup: false,
      salesActivityBean: new SalesAnalaysisActivityPeriodDataBean(),
      backOrders: new Array(),
      order: "asc",
      sortField: "",
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const currentYear = new Date().getFullYear();
    this.currentYear = currentYear;
    this.year_1 = currentYear - 1;
    this.year_2 = currentYear - 2;
    this.year_3 = currentYear - 3;
    this.year_4 = currentYear - 4;
    this.loadPage();
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadFabricStyleActivityInquiryList(criteria);
  };
  loadFabricStyleActivityInquiryList = (criteria) => {
    if (SecurityAccessManager.SalesAnalysisInquiry_IsAccessible()) {
      ReportService.inquireFabricSalesActivity(
        criteria,
        this.loadfabricStyleActivityResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadfabricStyleActivityResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let inquiryDataList = response.data.result;
      let periodSalesData = [];
      let backOrders = [];
      let salesActivityBean = new SalesAnalaysisActivityPeriodDataBean();
      if (!isEmptyArray(response.data.result.periodSalesData)) {
        periodSalesData = response.data.result.periodSalesData;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      if (!isEmptyArray(response.data.result.backOrders)) {
        backOrders = response.data.result.backOrders;
      }
      if (response.data.result.salesActivityBean != null) {
        salesActivityBean = response.data.result.salesActivityBean;
      }
      this.setState({
        isInquiryDatasFound: true,
        inquiryDataList: periodSalesData,
        inquiryData: inquiryDataList,
        backOrders: backOrders,
        salesActivityBean: salesActivityBean,
        isShowClearCriteriaButton: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new FabricSalesActivityPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (SecurityAccessManager.SalesAnalysisInquiryPDFReport_IsAccessible()) {
        ReportService.generateFabricSalesActivityPrintReport(
          listRequest,
          this.generateFabricSalesActivityResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.SalesAnalysisInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateFabricSalesActivityPrintReport(
          listRequest,
          this.generateFabricSalesActivityExcelResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateFabricSalesActivityResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

    generateFabricSalesActivityExcelResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
          let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new FabricStyleYearlySalesCriteriaBean();
    criteria.companyCode = this.companyCode;
    this.setState({
      criteria: criteria,
      isShowResetButton: false,
      isShowClearCriteriaButton: false,
      isDisableFields: false,
    });
  };
  resetInquiry = () => {
    let criteria = new FabricStyleYearlySalesCriteriaBean();
    criteria.companyCode = this.companyCode;
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: false,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  yearPercentConvertor = (data, rowData, type) => {
    let returnValue = "";
    let percentValue = "";
    if (!isEmptyString(data)) {
      returnValue = data;
    } else {
      returnValue = "N/A";
    }
    if (type == 1) {
      if (rowData.yearAmount4 != null) {
        percentValue = "(" + String(rowData.yearAmount4.toFixed(2)) + "%)";
      }
    } else if (type == 2) {
      if (rowData.yearAmount5 != null) {
        percentValue = "(" + String(rowData.yearAmount5.toFixed(2)) + "%)";
      }
    }
    if (!isEmptyString(percentValue)) {
      returnValue = returnValue + percentValue;
    }
    return returnValue;
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";

      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.inquiryDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ inquiryDataList: sorted });
    }
  };
  handleSortingBackOrdersChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingBackOrders(sortField, sortOrder);
    }
  };
  handleSortingBackOrders = (sortField, sortOrder) => {
    let list = this.state.backOrders;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ backOrders: sorted });
    }
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let salesActivityBean = this.state.salesActivityBean;
    let backOrders = this.state.backOrders;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          loadingText={this.state.loadingText}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
        />
        {this.state.isInquiryDatasFound && (
          <div className="div_inline">
            <div className="div_70_no_overflow">
              {" "}
              <div className="div_Custom_8">
                <Row>
                  <Col sm="">
                    <FormLabel>Sales Analysis</FormLabel>
                  </Col>
                </Row>
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th
                        onClick={(e) =>
                          this.handleSortingChange(e, "monthName")
                        }
                      >
                        Header
                        {this.state.order === "desc" &&
                        this.state.sortField === "monthName" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingChange(e, "yearAmount1")
                        }
                      >
                        {this.currentYear}
                        {this.state.order === "desc" &&
                        this.state.sortField === "yearAmount1" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingChange(e, "yearAmount2")
                        }
                      >
                        {this.year_1}
                        {this.state.order === "desc" &&
                        this.state.sortField === "yearAmount2" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingChange(e, "yearAmount3")
                        }
                      >
                        {this.year_2}
                        {this.state.order === "desc" &&
                        this.state.sortField === "yearAmount3" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingChange(e, "yearAmount6")
                        }
                      >
                        {this.year_3}
                        {this.state.order === "desc" &&
                        this.state.sortField === "yearAmount6" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingChange(e, "yearAmount7")
                        }
                      >
                        {this.year_4}
                        {this.state.order === "desc" &&
                        this.state.sortField === "yearAmount7" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th>
                        {this.currentYear} vs {this.year_1}
                      </th>
                      <th>
                        {this.currentYear} vs {this.year_2}
                      </th>
                    </tr>
                  </thead>
                  {inquiryDataList != null && (
                    <tbody>
                      {inquiryDataList.map((inquiryInfo, index) => (
                        <tr key={index}>
                          <td>{inquiryInfo.monthName}</td>
                          <td class="text-right">
                            {/* {inquiryInfo.yearAmount1.toLocaleString("en", {
                              minimumFractionDigits: 2,
                            })} */}

                            {toCommaSeperatedAmount(inquiryInfo.yearAmount1)}
                          </td>
                          <td class="text-right">
                            {toCommaSeperatedAmount(inquiryInfo.yearAmount2)}
                          </td>
                          <td class="text-right">
                            {toCommaSeperatedAmount(inquiryInfo.yearAmount3)}
                          </td>
                          <td class="text-right">
                            {toCommaSeperatedAmount(inquiryInfo.yearAmount6)}
                          </td>
                          <td class="text-right">
                            {toCommaSeperatedAmount(inquiryInfo.yearAmount7)}
                          </td>
                          <td class="text-right">
                            {this.yearPercentConvertor(
                              inquiryInfo.decreaseOrIncreaseValue1,
                              inquiryInfo,
                              1
                            )}
                          </td>
                          <td class="text-right">
                            {this.yearPercentConvertor(
                              inquiryInfo.decreaseOrIncreaseValue2,
                              inquiryInfo,
                              2
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
                {inquiryDataList.length != 0 ? null : (
                  <div className="no_Data">{"NO DATA"}</div>
                )}
              </div>
            </div>
            <div className="div_30_no_overflow">
              {" "}
              <div className="div_Custom_4">
                <Row>
                  <Col sm="">
                    <FormLabel>SalesOrder BackLog Activity</FormLabel>
                  </Col>
                </Row>
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th>Period</th>
                      <th
                        onClick={(e) =>
                          this.handleSortingBackOrdersChange(
                            e,
                            "backOrderAmount"
                          )
                        }
                      >
                        Amount
                        {this.state.order === "desc" &&
                        this.state.sortField === "backOrderAmount" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                    </tr>
                  </thead>
                  {backOrders != null && (
                    <tbody>
                      {backOrders.map((inquiryInfo, index) => (
                        <tr key={index}>
                          <td>
                            {inquiryInfo.monthName}/{inquiryInfo.year}
                          </td>
                          <td class="text-right">
                            {toCommaSeperatedAmount(
                              inquiryInfo.backOrderAmount
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
                {backOrders.length != 0 ? null : (
                  <div className="no_Data">{"NO DATA"}</div>
                )}
              </div>
              <Row>
                <Col sm="">
                  <FormLabel>Sales Summary</FormLabel>
                </Col>
              </Row>
              <div className="header_div">
                <Row>
                  <Col sm="">
                    <FormLabel>YTD Sales</FormLabel>
                  </Col>
                  <Col className="summary_text_box" sm="">
                    <NumberFormatInputbox
                      value={salesActivityBean.yearlySalesAmount}
                      className="summary_input text-right"
                      decimalScale={2}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="">
                    <FormLabel>MTD Sales</FormLabel>
                  </Col>
                  <Col className="summary_text_box" sm="">
                    <NumberFormatInputbox
                      value={salesActivityBean.monthlySalesAmount}
                      className="summary_input text-right"
                      decimalScale={2}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="">
                    <FormLabel>Day Sales</FormLabel>
                  </Col>
                  <Col className="summary_text_box" sm="">
                    <NumberFormatInputbox
                      value={salesActivityBean.daySalesAmount}
                      className="summary_input text-right"
                      decimalScale={2}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="">
                    <FormLabel>YTD Booked Orders</FormLabel>
                  </Col>
                  <Col className="summary_text_box" sm="">
                    <NumberFormatInputbox
                      value={salesActivityBean.yearlyBookedOrdersAmount}
                      className="summary_input text-right"
                      decimalScale={2}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="">
                    <FormLabel>AR Collected(YTD)</FormLabel>
                  </Col>
                  <Col className="summary_text_box" sm="">
                    <NumberFormatInputbox
                      value={salesActivityBean.arCollectedAmount}
                      className="summary_input text-right"
                      decimalScale={2}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="">
                    <FormLabel>AR Balance (YTD)</FormLabel>
                  </Col>
                  <Col className="summary_text_box" sm="">
                    <NumberFormatInputbox
                      value={salesActivityBean.arBalanceAmount}
                      className="summary_input text-right"
                      decimalScale={2}
                      disabled={true}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
function SalesAnalysisInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <SalesAnalysis {...props} name="" /> <br />
    </div>
  );
}

export default SalesAnalysisInquiry;
